import { render, staticRenderFns } from "./OverflowContainer.vue?vue&type=template&id=eea47ab6&scoped=true&"
var script = {}
import style0 from "./OverflowContainer.vue?vue&type=style&index=0&id=eea47ab6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eea47ab6",
  null
  
)

export default component.exports